/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  Address,
  CountryCode,
} from '@/models';

export function formatAddress(address: Address) {
  if (address.country === CountryCode.TWN) {
    // https://en.wikipedia.org/wiki/Address#Taiwan
    //
    // FIXME: Support international format.
    let s = '';
    if (address.postalCode) {
      s += address.postalCode + ' ';
    }
    if (address.city) {
      s += address.city;
    }
    if (address.stateOrRigion) {
      s += address.stateOrRigion;
    }
    s += address.address1;
    if (address.address2) {
      s += address.address2;
    }
    return s;
  } else {
    // https://en.wikipedia.org/wiki/Address#United_States
    let s = address.address1;
    if (address.address2) {
      s += address.address2;
    }
    if (address.city) {
      s += `, ${address.city}`;
    }
    if (address.stateOrRigion) {
      s += `, ${address.stateOrRigion}`;
    }
    if (address.postalCode) {
      s += ` ${address.postalCode}`;
    }
    return s;
  }
}
